<template>
  <button
    :class="[
      'botao-padrao',
      { 'arredondado-esquerda': arredondadoEsquerda },
      { 'arredondado-direita': arredondadoDireita },
      { desabilita: desabilita },
      cor ? cor : ''
    ]"
    :style="padding ? `padding: 0 ${padding}px` : ''"
    :disabled="desabilita"
  >
    <div
      v-if="loading"
      :class="['loading-icone', 'botao-icone', tamanho ? '' : 'icone-tamanho']"
      :style="tamanho ? `font-size: ${tamanho}px;` : ''"
    >
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <font-awesome-icon
      v-else
      :class="['botao-icone', tamanho ? '' : 'icone-tamanho']"
      :style="tamanho ? `font-size: ${tamanho}px;` : ''"
      :icon="icone"
    />
  </button>
</template>

<script>
export default {
  name: "BotaoTipoIcone",
  props: {
    desabilita: Boolean,
    arredondadoEsquerda: Boolean,
    arredondadoDireita: Boolean,
    loading: Boolean,
    icone: String,
    nome: String,
    cor: String,
    tamanho: String,
    padding: String
  }
};
</script>

<style lang="scss" scoped>
.botao-padrao {
  text-decoration: none;
  transition: all 0.3s ease;
  height: 30px;
  width: 30px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #969896;
  color: var(--branco);
  font-family: "Roboto Condensed";
  box-shadow: 2px 2px 4px #00000042;
  &:hover {
    background: #777975;
  }
  &:focus {
    background: #d1d2d1;
  }
}
.botao-icone {
  color: var(--branco);
}
.icone-tamanho {
  font-size: 18px;
}
.arredondado-esquerda {
  border-radius: 50px 0 0 50px;
  padding: 5px 7px 5px 12px;
}
.arredondado-direita {
  border-radius: 0 50px 50px 0;
  padding: 5px 12px 5px 7px;
}
.verde {
  background: var(--verde2);
  &:hover {
    background: var(--verde3);
  }
  &:focus {
    background: var(--verde1);
  }
}
.vermelho {
  background: var(--vermelho2);
  &:hover {
    background: var(--vermelho3);
  }
  &:focus {
    background: var(--vermelho1);
  }
}
.azul {
  background: var(--azul2);
  &:hover {
    background: var(--azul3);
  }
  &:focus {
    background: var(--azul1);
  }
}
.laranja {
  background: var(--laranja2);
  &:hover {
    background: var(--laranja3);
  }
  &:focus {
    background: var(--laranja1);
  }
}
.desabilita {
  opacity: 0.5;
  filter: saturate(0.4) contrast(0.4) brightness(1.2);
}
.loading-icone {
  padding-top: 2px;
}
</style>
